import { FC } from 'react';
import { Calendar } from '../../../../../packages/Calendar';
import styles from './DropdownDates.css';

interface IDropdownDatesProps {
  min: Date;
  max: Date;
  valueFrom: Date | null;
  valueTo: Date | null;

  onChange(from: Date | undefined, to: Date | undefined): void;
}

export const DropdownDates: FC<IDropdownDatesProps> = ({ min, max, valueFrom, valueTo, onChange }) => {
  return (
    <div className={styles['dropdown']} data-testid="DropdownDates">
      <Calendar minDate={min} maxDate={max} fromValue={valueFrom} toValue={valueTo} onChange={onChange} />
    </div>
  );
};
